import React from "react";
import LockedFeature from "../../components/common/LockedFeature/LockedFeature";

/**
 * LockedFeaturePage
 *
 * Dedicated page view to display when a user navigates to a feature
 * that is locked under their current subscription tier.
 */
const LockedFeaturePage = (props) => {
  return <LockedFeature fullPage {...props} />;
};

export default LockedFeaturePage;
